<template>
    <div id="customDropdown_main">
        <div @click="toggle" id="customDropdown_head" class="bg-white ff-inter" :class="selected ? 'fc-main' : 'fc-gray-dark'">
            <i id="customDropdown_icon" class="fas" :class="icon"></i>
            <span class="fc-black fs-small">{{ selected ? selected.name : name }}</span>
            <i id="customDropdown_caret" class="fas fa-caret-down"></i>
        </div>
        <div v-on-clickaway="toggle" v-if="open" id="customDropdown_body" class="bg-white shadow-1">
            <div @click="select(d)" v-for="d in data" class="customDropdown_d ff-inter bt-hover-dark bg-white fs-normal noselect">
                {{ d.name }}
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'

  export default {
    name: 'customDropdown',
    mixins: [ clickaway ],
    props: {
      data: {
        type: Array,
        default: []
      },
      name: {
        type: String,
        default: 'Dropdown'
      },
      icon: {
        type: String,
        default: 'fa-newspaper'
      }
    },
    data(){
      return{
        open: false,
        selected: null,
      }
    },
    methods: {
      toggle(){
        this.open = !this.open;
      },
      select(data){
        this.selected = data;
        this.toggle();
        this.$emit('input', this.selected);
        this.$emit('ddChange');
      }
    },
    watch: {
      data(){
        this.selected = null;
      }
    }
  }
</script>

<style scoped>
    #customDropdown_main{
        display: flex;
        height: 100%;
        width: 100%;
        position: relative;
    }
    #customDropdown_head{
        display: flex;
        height: 100%;
        width: 100%;
        border: 1px solid var(--color-gray);
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
    }
    #customDropdown_icon{
        margin-right: 10px;
    }
    #customDropdown_caret{
        margin-left: auto;
    }
    #customDropdown_body{
        display: flex;
        position: absolute;
        top: 45px;
        width: calc(100% - 2px);
        flex-direction: column;
        padding-top: 10px;
        padding-bottom: 10px;
        z-index: 10;
        align-items: center;
        overflow-y: scroll;
        max-height: 200px;
    }
    #customDropdown_count{
        margin-left: 2px;
    }
    .customDropdown_d{
        display: flex;
        width: calc(100% - 40px);
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .customDropdown_d:nth-last-child(2){
        margin-bottom: 10px;
    }
</style>
